import { http } from "@/http";

export const setStudyLanguage = async(id:string, language:string):Promise<void> => {
	await http.patch(`studies/${id}/settings`, { language });
};